export const UPDATE_COLLECTIONS_LIST = "UPDATE_COLLECTIONS_LIST";
export const SET_COLLECTIONS_LIST = "SET_COLLECTIONS_LIST";
